// @flow

import * as React from 'react';

import { useHref, useLocation } from 'react-router-dom';

import { localeSelector } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectLocaleItems } from '../../../modules/app';
import { NavigationDropDown } from '../NavigationDropDown';

export type Props = {
  className?: string,
};

function LocaleSelector({ className }: Props): React.MixedElement {
  const currentLocaleCode = useAppSelector(localeSelector);
  const currentLocation = useLocation();
  const currentURL = useHref(currentLocation);

  const items = useAppSelector(state => selectLocaleItems(state, currentURL));

  return (
    <NavigationDropDown
      id="layout-locale-selector"
      placement="bottom"
      navigationItems={items}
      label={currentLocaleCode}
      className={className}
    />
  );
}

export default LocaleSelector;
